/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InformationMetadata
 */
export interface InformationMetadata {
    /**
     * 
     * @type {string}
     * @memberof InformationMetadata
     */
    taskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMetadata
     */
    workAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMetadata
     */
    isPmkTask?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InformationMetadata
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMetadata
     */
    techId?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMetadata
     */
    stepMetadataType: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMetadata
     */
    message?: string;
}

/**
 * Check if a given object implements the InformationMetadata interface.
 */
export function instanceOfInformationMetadata(value: object): value is InformationMetadata {
    if (!('stepMetadataType' in value) || value['stepMetadataType'] === undefined) return false;
    return true;
}

export function InformationMetadataFromJSON(json: any): InformationMetadata {
    return InformationMetadataFromJSONTyped(json, false);
}

export function InformationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InformationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'workAccess': json['workAccess'] == null ? undefined : json['workAccess'],
        'isPmkTask': json['isPmkTask'] == null ? undefined : json['isPmkTask'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'stepMetadataType': json['stepMetadataType'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function InformationMetadataToJSON(json: any): InformationMetadata {
    return InformationMetadataToJSONTyped(json, false);
}

export function InformationMetadataToJSONTyped(value?: InformationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'workAccess': value['workAccess'],
        'isPmkTask': value['isPmkTask'],
        'taskName': value['taskName'],
        'techId': value['techId'],
        'stepMetadataType': value['stepMetadataType'],
        'message': value['message'],
    };
}

